import {
  EDIT_USER,
  SET_USER,
  RESET_USER,
  REDUCE_STORAGE_USER,
  INCREASE_STORAGE_USER,
} from '../actions/userActions';

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case EDIT_USER:
      return {
        ...state,
        ...action.value,
      };
    case SET_USER:
      return action.value;
    case REDUCE_STORAGE_USER:
      return {
        ...state,
        storage_left: state.storage_left - action.value,
      };
    case INCREASE_STORAGE_USER:
      return {
        ...state,
        storage_left: state.storage_left + action.value,
      };
    case RESET_USER:
      return initialState;
    default:
      return state;
  }
}
